<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="3">
        <date-filter store="audience" periodType="past-only" format="month" />
      </v-col>
      <v-col cols="9" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter";

import useAxios from "@/hooks/useAxios";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    DateFilter,
  },
  setup(props, { emit }) {
    const { isLoading } = useAxios();

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      isLoading,
    };
  },
};
</script>

<style></style>
